export default "__VITE_ASSET__CAET8gMQ__"